(() => {
  // app/scripts/common/component/syncCart.js
  var SyncCartItem = class extends HTMLElement {
    connectedCallback() {
      const a = this.querySelector("a");
      const isLogin = this.getAttribute("data-is-login");
      if (isLogin === "false") {
        a.href = "/pages/mayway-dispensary";
        return;
      }
      const cookie = this.getCookie("cart");
      if (!cookie) {
        console.log("Not found cart cookie!");
        return;
      }
      let url = a.href;
      url += a.href.includes("?") ? "&" : "?";
      url += `cartId=${cookie}`;
      a.href = url;
    }
    getCookie(name) {
      const cookieString = `; ${document.cookie}`;
      const cookies = cookieString.split(`; ${name}=`);
      if (cookies.length === 2) {
        return cookies.pop().split(";").shift();
      }
      return null;
    }
  };
  customElements.define("sync-cart", SyncCartItem);

  // app/scripts/theme-custom.js
  window.addEventListener("load", () => {
    const cartIdFromUrl = getCartIdFromUrl();
    if (cartIdFromUrl || cartIdFromUrl === "") {
      const cartIdCookie = decodeURIComponent(getCookie("cart"));
      if (cartIdCookie !== cartIdFromUrl) {
        console.log("Updating cartId cookie");
        setCookie("cart", cartIdFromUrl, 14);
        window.location.href = `${Shopify.routes.root}cart`;
      } else {
        console.log("Cart cookie is already up to date");
      }
    } else {
      console.log("Cart ID not found in URL");
    }
  });
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
      return parts.pop().split(";").shift();
    return null;
  }
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = /* @__PURE__ */ new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
  }
  function getCartIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get("cartId");
  }
})();
